<template>
  <section
    class="blade-hero"
    :style="`background:url(${require('../assets/' +
      content.background)}) no-repeat; background-size: cover;`"
  >
    <div class="container">
      <div class="col-6" :class="[alignment === 'right' ? 'offset-6' : '']">
        <div class="content-area">
          <strong class="header-eyebrow" v-html="content.product"></strong>
          <h2 v-html="content.header"></h2>
          <ul class="list-inline">
            <li class="list-inline-item">
              <b-button :variant="btnMain" to="/products/headphones"
                >Buy</b-button
              >
            </li>
            <li class="list-inline-item">
              <b-button :variant="btnSecondary" to="/products/headphones"
                >Learn</b-button
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "blade-hero",
  props: {
    alignment: {
      type: String,
      default: "left",
    },
    container: {
      type: String,
      default: "full",
    },
    content: {
      type: Object,
    },
    btnMain: {
      type: String,
      default: "black",
    },
    btnSecondary: {
      type: String,
      default: "white",
    },
  },
};
</script>

<style scoped lang="scss">
.blade-hero {
  padding-top: 47.91666667%;
  position: relative;
  .container {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;

    & > div {
      display: flex;
      height: 100%;
      align-items: center;
      justify-content: center;
    }
  }
}
.content-area {
  h2,
  p,
  strong {
    color: #fff;
  }
  .header-eyebrow {
    font-size: 1.041666667vw;
    @media screen and (min-width: map-get($grid-breakpoints, xxl)) {
      font-size: 20px;
    }
  }
  h2 {
    font-size: 3.125vw;
    @media screen and (min-width: map-get($grid-breakpoints, xxl)) {
      font-size: 60px;
    }
  }
}
</style>
